"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _usePagination = _interopRequireDefault(require("./hooks/usePagination"));
var _PaginationItem = _interopRequireDefault(require("./components/PaginationItem"));
var _types = require("./types");
var Styled = _interopRequireWildcard(require("./style"));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var __assign = void 0 && (void 0).__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var Pagination = /*#__PURE__*/(0, _react.forwardRef)(function (props, ref) {
  var _a = props.size,
    size = _a === void 0 ? 'normal' : _a,
    _b = props.variant,
    variant = _b === void 0 ? 'primary' : _b,
    disabled = props.disabled,
    onChange = props.onChange,
    activePage = props.activePage,
    totalPages = props.totalPages,
    visiblePages = props.visiblePages,
    _c = props.showPreviousPageButton,
    showPreviousPageButton = _c === void 0 ? true : _c,
    _d = props.showFirstPageButton,
    showFirstPageButton = _d === void 0 ? true : _d,
    _e = props.showSeparationIndicator,
    showSeparationIndicator = _e === void 0 ? true : _e,
    _f = props.showLastPageButton,
    showLastPageButton = _f === void 0 ? true : _f,
    _g = props.showNextPageButton,
    showNextPageButton = _g === void 0 ? true : _g;
  var paginationBlueprint = (0, _usePagination.default)({
    activePage: activePage,
    totalPages: totalPages,
    visiblePages: visiblePages,
    showPreviousPageButton: showPreviousPageButton,
    showFirstPageButton: showFirstPageButton,
    showSeparationIndicator: showSeparationIndicator,
    showLastPageButton: showLastPageButton,
    showNextPageButton: showNextPageButton
  });
  var handleOnItemClick = (0, _react.useCallback)(function (type, page) {
    switch (type) {
      case _types.PaginationElementTypes.NextPageButton:
        onChange(activePage + 1);
        break;
      case _types.PaginationElementTypes.PreviousPageButton:
        onChange(activePage - 1);
        break;
      case _types.PaginationElementTypes.PageButton:
        onChange(page);
        break;
    }
  }, [onChange, activePage]);
  return (0, _jsxRuntime.jsx)(Styled.Wrapper, __assign({
    ref: ref
  }, {
    children: paginationBlueprint.map(function (item, idx) {
      return /*#__PURE__*/(0, _react.createElement)(_PaginationItem.default, __assign({}, item, {
        key: "".concat(item.type, "-").concat(item.page ? item.page : 'item', "-").concat(idx),
        size: size,
        variant: variant,
        disabled: disabled || item.disabled,
        onClick: handleOnItemClick
      }));
    })
  }));
});
Pagination.displayName = 'Pagination';
var _default = Pagination;
exports.default = _default;